import React from "react";
import Image from "next/image";
import { Button, Grid, PaddedScreenContainer } from "~/components";
import { CSS, styled } from "~/styles/stitches.config";

const gridCss: CSS = {
  mb: "$10",
  alignContent: "center",
  alignItems: "center",
  "@bp1": {
    marginBottom: 100,
  },
};

const ImageContainer = styled("div", {
  gridColumn: "1/-1",
  mb: "$4",
  "@bp1": {
    marginBottom: 0,
    gridColumn: "2/span 6",
    paddingRight: 40,
  },
});

const ImageFrame = styled("div", {
  position: "relative",
  aspectRatio: 1,
  borderRadius: "$xl",
  overflow: "hidden",
});

const TextContainer = styled("div", {
  gridColumn: "1/-1",
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  gap: 8,
  mb: "$3",
  "@bp1": {
    gap: 16,
    gridColumn: "8/span 4",
    textAlign: "left",
    justifyContent: "flex-start",
    marginBottom: 0,
  },
});

const ButtonsContainer = styled("div", {
  display: "flex",
  flexDirection: "row",
  gap: 8,
  justifyContent: "center",
  alignItems: "center",
  mt: "$2",
  "@bp1": {
    gap: 24,
    justifyContent: "flex-start",
  },
});

export const HomeQuote = () => {
  return (
    <PaddedScreenContainer>
      <Grid css={gridCss}>
        <ImageContainer>
          <ImageFrame>
            <Image
              src={"/cotiza-2@2x.png"}
              alt={"Directorio SofíaMed"}
              quality={100}
              fill
              sizes={"(min-width: 1024px) 50vw, 100vw"}
              loading={"lazy"}
            />
          </ImageFrame>
        </ImageContainer>
        <TextContainer>
          <h4>¡Cotiza tu seguro!</h4>
          <p>
            Un seguro para cubrir cuidados médicos chicos o hasta
            hospitalizaciones.
          </p>
          <ButtonsContainer>
            <Button
              title={"Cotiza ahora"}
              onClick={() =>
                window.open(
                  "https://cotiza.sofiasalud.com/?_ga=2.19392381.410664251.1688508996-1549897363.1686765548",
                )
              }
            />
            <Button
              title={"Conoce más"}
              type={"ghost"}
              onClick={() =>
                window.open("https://www.sofiasalud.com/individual")
              }
            />
          </ButtonsContainer>
        </TextContainer>
      </Grid>
    </PaddedScreenContainer>
  );
};
